import { DescriptionList } from "@prequel/shared-components";

import Timestamp from "@/components/Timestamp";
import { ExistingWebhook, styleDeliveryMethod } from "@/types";

type WebhookDetailsSectionProps = {
  webhook: ExistingWebhook;
};

const WebhookDetailsSection = ({ webhook }: WebhookDetailsSectionProps) => {
  return (
    <>
      <SectionHeader />
      <SectionContent webhook={webhook} />
    </>
  );
};

const SectionHeader = () => (
  <div className="space-y-1">
    <h3 className="text-lg/6 font-medium text-gray-900">Details</h3>
  </div>
);

const SectionContent = ({ webhook }: WebhookDetailsSectionProps) => (
  <div className="mt-6">
    <DescriptionList>
      <DescriptionList.Item label="ID" value={webhook.id} />
      <DescriptionList.Item label="Name" value={webhook.name} />
      <DescriptionList.Item label="Delivery Method" value={styleDeliveryMethod(webhook.vendor)} />
      <DescriptionList.Item label="URL" value={webhook.url} />
      <DescriptionList.Item label="Events" value={webhook.events.join(", ")} />
      <DescriptionList.Item label="Created At" value={<Timestamp timestamp={webhook.created_at} />} />
      <DescriptionList.Item label="Updated At" value={<Timestamp timestamp={webhook.updated_at} />} />
    </DescriptionList>
  </div>
);

export default WebhookDetailsSection;
